<template>
    <div :class="animate ? 'p-3 text-center animate-opacity' : 'p-3 text-center opacity-75'" :style="'width : ' + width">
        <img :class="imageClass" :src="`${publicPath}/img/no-data.png`" />
    </div>
</template>
<script>
export default {
    props:  {
        animate: {
            default: false,
            type: Boolean,
        },
        width: {
            default: "100vw",
            type: String
        },
        imageClass: {
            default: "",
            type: String
        }
    }
}
</script>
<style scoped>
    @keyframes opacity-animation { 
        0% {
            opacity: 0.6;
        }
        
        50% {
            opacity: 1;
        }
        
        100% {
            opacity: 0.6;
        }
    }
    .animate-opacity {
        animation: opacity-animation 2s infinite;
    }
    .no-data-image {
        width: 90vw;
    }
</style>